import { css } from "@emotion/react";

export default {
  user: css`
    float: right;
    height: 64px;
  `,
};
